import http from "./HttpService";

const endpoint = process.env.VUE_APP_REWARD_CENTER_BASE_URL;

export const fetchAll = (params) => {
  return http.get('/rewards/filter', {
    baseURL: endpoint,
    params,
  });
};

export const submitNewReward = (data) => {
  return http.post("/register/reward", data, {
    baseURL: endpoint,
  });
};

export const submitNewRewardCondition = (data) => {
  return http.post("/register/rewardcondition", data, {
    baseURL: endpoint,
  });
};

export const findReward = (id) => {
  return http.get(`/rewards/${id}`, {
    baseURL: endpoint,
  });
};

export const updateReward = (data) => {
  return http.post(`/rewards/activate`, data, {
    baseURL: endpoint,
  });
};

export const fetchRewardConditions = (params) => {
  return http.get(`/rewardconditions/filter`, {
    params,
    baseURL: endpoint,
  });
};

export const fetchAchievedRewards = (params) => {
  return http.get(`/achieved/rewards/filter`, {
    params,
    baseURL: endpoint,
  });
};

export const confirmCancelAchievedReward = (data) => {
  return http.post(`/achieved/rewards/confirm`, data, {
    baseURL: endpoint,
  });
};

export const fetchTotalReport = (params) => {
  return http.get(`/reports/total`, {
    params,
    baseURL: endpoint,
  });
}

export const fetchUserReport = (params) => {
  return http.get(`/reports/users`, {
    params,
    baseURL: endpoint,
  });
}
